/*eslint-disable*/
import api from '../'

class GamePDFApi {

    //POST: gamePDF
    static getPDF(game) {
      return api.axios.post('/game-pdf', {game}).then(response => response.data);
    }

}

export default GamePDFApi;
